import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VideoContainerComponent } from './video-container.component';

@Injectable({
  providedIn: 'root',
})
export class VideoContainerService {
  constructor(private readonly dialog: MatDialog) {}

  playVideo(src: string, event?: string) {
    this.dialog.open(VideoContainerComponent, {
      maxWidth: '95vw',
      maxHeight: '95vh',
      panelClass: 'video-dialog',
      data: { src, event },
    });
  }
}
